import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import { TutorialsTypes } from './helper-tooltip.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    tutorialComplete: builder.mutation<ApiResponse, { tutorial: TutorialsTypes; completed: boolean }>({
      query: ({ tutorial, completed }) => ({
        url: 'users/tutorial',
        method: 'PATCH',
        body: { tutorial, completed },
      }),
      invalidatesTags: [{ type: RTKQueryTag.User }],
    }),
  }),
});

export const { useTutorialCompleteMutation } = extendedApiSlice;
